import { useI18n } from 'vue-i18n';
import { DateTime } from 'luxon';
import * as yup from 'yup';

export default () => {
  const { t } = useI18n();

  const schema = yup.object().shape({
    requirePickupOrDelivery: yup.boolean().nullable().optional(),
    local_menu_group: yup.string().optional(),
    eventMenu: yup.object().nullable().required(t('errorMessages.required')),
    startTime: yup.date().required(t('errorMessages.required')),
    endTime: yup.date().required(t('errorMessages.required')),
    repeat: yup
      .mixed()
      .test('repeat-type', 'Invalid repeat type', (value) => {
        return typeof value === 'string' || typeof value === 'object';
      })
      .required(t('errorMessages.calendar.repeat')),
    startDate: yup.date().required(t('errorMessages.required')),
    endDate: yup.date().when('startDate', (startDate, schema) => {
      if (startDate) {
        return schema.min(
          DateTime.fromJSDate(startDate).toJSDate(),
          t('errorMessages.calendar.endDateBeforeStartDate'),
        );
      }
      return schema;
    }),
    pickup: yup.boolean().nullable().optional(),
    delivery: yup.boolean().nullable().optional(),
    hidden: yup.boolean(),
    noEndDate: yup.boolean(),
    priceLevel: yup.string().optional(),
  });

  return {
    schema,
  };
};
